/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The StatisticsItemVo model module.
   * @module clazz_course/model/StatisticsItemVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>StatisticsItemVo</code>.
   * @alias module:clazz_course/model/StatisticsItemVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>StatisticsItemVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/StatisticsItemVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/StatisticsItemVo} The populated <code>StatisticsItemVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'value')) {
        obj['value'] = ApiClient.convertToType(data['value'], 'Number');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'formatValue')) {
        obj['formatValue'] = ApiClient.convertToType(data['formatValue'], 'String');
      }
    }
    return obj;
  }

  /**
   * COST_TIME累计时长、READING_TIME阅读时长、READING_PROGRESS阅读进度、VIDEO_TIME视频时长、EXERCISE_COUNT练习题次、EXERCISE_SCORE练习正确率、MAX_DAY_COST_TIME最长单日学习时间、EXTENDED_COUNT拓展学习、NOTES_COUNT笔记条数、HIGHTLIGHT_COUNT高亮条数、THREAD_COUNT发起讨论次数、COMMENT_COUNT参与讨论次数
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * name
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 原始值
   * @member {Number} value
   */
  exports.prototype['value'] = undefined;
  /**
   * 格式化的值
   * @member {String} formatValue
   */
  exports.prototype['formatValue'] = undefined;



  export default exports;
;


